module.exports = __webpack_public_path__ + "img/Trash_icon.4a1ec184.svg";